"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowRight } from "lucide-react";
import { LandvestHandoffLink } from "@/components/layout/LandvestHandoffLink";
import type { MegaMenuConfig } from "@/lib/navigation";
interface MegaMenuFeaturedCardProps {
  card: NonNullable<MegaMenuConfig["featuredCard"]>;
  onClose: () => void;
}

/** Dark teaser card in a shelf column, linked as a whole (Kompensationsberatung). */
export function MegaMenuFeaturedCard(t0) {
  const $ = _c(18);
  const {
    card,
    onClose
  } = t0;
  let t1;
  if ($[0] !== card.badge) {
    t1 = card.badge && <span className="self-start rounded-full bg-neon px-3 py-[5px] text-[11px] font-extrabold uppercase tracking-[0.12em] text-primary">{card.badge}</span>;
    $[0] = card.badge;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== card.headline) {
    t2 = <span className="text-2xl font-extrabold leading-[1.15] tracking-[-0.02em]">{card.headline}</span>;
    $[2] = card.headline;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== card.subtitle) {
    t3 = <span className="text-sm leading-normal text-surface/80">{card.subtitle}</span>;
    $[4] = card.subtitle;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <span className="flex flex-col gap-3">{t1}{t2}{t3}</span>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== card.ctaLabel) {
    t6 = <span className="flex items-center gap-1.5 text-sm font-bold text-neon">{card.ctaLabel}{t5}</span>;
    $[11] = card.ctaLabel;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== card.ctaHref || $[14] !== onClose || $[15] !== t4 || $[16] !== t6) {
    t7 = <LandvestHandoffLink href={card.ctaHref} onClick={onClose} role="menuitem" className="group flex flex-col justify-between gap-5 rounded-[20px] bg-primary p-7 text-surface">{t4}{t6}</LandvestHandoffLink>;
    $[13] = card.ctaHref;
    $[14] = onClose;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}